<template>
  <div>
    <h3>样品寄出</h3>
    <div
      class="confirm-box"
      v-for="(item, index) in tableData"
      :key="index"
    >
      <div>
        <el-image
          v-if="item.mainImage"
          style="width: 80px; height: 80px"
          :src="item.mainImage + $ImgQuality30"
          :preview-src-list="[item.mainImage + $ImgPreviewQuality]"
          fit="contain">
         >
          <div slot="placeholder" class="sample-image-slot">
            加载中
          </div>
        </el-image>
        <p v-else style="width: 80px"></p>
      </div>
      <el-form
        class="confirm-info-form"
        ref="confirmInfoForm"
        :model="item"
        :inline="true"
        label-width="120px"
        size="mini"
        :rules="rules"
      >
        <el-row>
          <el-col
            :span="8"
            v-for="(el, index) in tableFormData"
            :key="index"
          >
            <el-form-item :label="el.label" :prop="el.prop">
              <span v-if="el.type === 'date'">
                <el-date-picker
                  v-model="item[el.prop]"
                  type="datetime"
                  placeholder="选择时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                />
              </span>
              <span v-else-if="el.type === 'input'">
                <el-input
                  class="small-input-padding"
                  v-model="item[el.prop]"
                  maxlength="30"
                  show-word-limit
                />
              </span>
              <span v-else-if="el.type === 'textarea'">
                <el-input
                  type="textarea"
                  v-model="item[el.prop]"
                  maxlength="30"
                  show-word-limit
                  style="width: 200px"
                />
              </span>
              <span v-else style="word-break: break-all;">{{item[el.prop]}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="btns">
      <el-button
        type="primary"
        @click="save"
        >提交</el-button
      >
      <el-button
        @click="back"
        >取消</el-button
      >
    </div>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import dayjs from 'dayjs';
export default {
  props: {
    removeTab: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      tableFormData: [
        { label: '寻样单编号', prop: 'code' },
        { label: '产品名称', prop: 'productName' },
        { label: '产品ID', prop: 'id' },
        { label: '申请时间', prop: 'createDate' },
        { label: '数量', prop: 'num' },
        { label: '单位', prop: 'orderUnit' },
        { label: '采购备注', prop: 'forSupplierRemark' },
        { label: '要求到样时间', prop: 'askArrivalTime' },
        { label: '回复到样时间', prop: 'actualArrivalTime' },
        { label: '备注', prop: 'supplierRemark' },
        { label: '寄出时间', prop: 'deliveryDate', type: 'date' },
        { label: '快递单号', prop: 'expressNo', type: 'input' },
        { label: '快递公司', prop: 'express', type: 'textarea' },
      ],
      tableData: [],
      rules: {
        deliveryDate: [
          { required: true, message: '请选择寄出时间', trigger: 'change' },
        ],
        expressNo: [
          { required: true, message: '请输入快递单号', trigger: 'blur' },
        ],
        express: [
          { required: true, message: '请输入快递公司', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {
    // table数据
    getListForm(val) {
      this.tableData = cloneDeep(val);
      this.clearProductInfoForm();
      this.tableData.map(item => {
        this.$set(item, 'deliveryDate', dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'))
        return item;
      })
    },
    save() {
      this.checkFormValid();
      // 校验寄出时间,快递公司,快递单号不能为空
      let params = this.tableData;
      const errArr1 = params.filter(
        item => item.deliveryDate === '' || !item.deliveryDate,
      );
      if (errArr1.length > 0) {
        this.$message.error(
          `产品名称为【${errArr1[0].productName}】的商品，寄出时间不能为空`,
        );
        return;
      }
      const errArr2 = params.filter(
        item => item.express === '' || !item.express,
      );
      if (errArr2.length > 0) {
        this.$message.error(
          `产品名称为【${errArr2[0].productName}】的商品，快递公司不能为空`,
        );
        return;
      }
      const errArr3 = params.filter(
        item => item.expressNo === '' || !item.expressNo,
      );
      if (errArr3.length > 0) {
        this.$message.error(
          `产品名称为【${errArr3[0].productName}】的商品，快递单号不能为空`,
        );
        return;
      }
      const errArr4 = params.reduce((prev, cur) => {
        if (dayjs(cur.deliveryDate).isBefore(dayjs(cur.createDate))) {
          prev.push(cur);
        }
        return prev;
      }, []);
      if (errArr4.length > 0) {
        this.$message.error(
          `产品名称为【${errArr4[0].productName}】的商品，寄出时间不能早于申请时间`,
        );
        return;
      }

      this.saveLoading = true;
      this.$http.sample
        .batchAddDeliveryInfo(params)
        .then(() => {
          this.$message.success('操作成功');
          this.back();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    // 表单校验
    checkFormValid() {
      let formValid = []; // 正确数据
      this.$refs.confirmInfoForm.map(item => {
        item.validate(valid => {
          formValid.push(valid)
        });
      });
      return formValid.every(Boolean);
    },
    // 清空form表单
    clearProductInfoForm() {
      this.$nextTick(() => {
        this.$refs.confirmInfoForm.map(el => {
          el.clearValidate();
        });
      });
    },
    back() {
      this.tableData = [];
      this.removeTab('historyBill', 'history');
    },
  },
};
</script>

<style lang="less" scoped>
h3 {
  text-align: center;
}
/deep/ .confirm-box {
  display: flex;
  border-bottom: 1px dashed #ccc;
  padding: 10px 20px 10px;
  .confirm-info-form {
    margin-left: 20px;
    .el-form-item {
      margin-bottom: 5px;
    }
    .el-form-item__content {
      width: calc(100% - 120px);
    }
  }
}
.btns {
  text-align: center;
  padding: 20px 0;
}
</style>
